var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
var searchQuery = function (state) {
    return state.versions ? state.versions.searchQuery : null;
};
var queryVersions = function (query, versionsData) {
    if (versionsData === void 0) { versionsData = []; }
    return versionsData.filter(function (row) {
        return Object.values(row).some(function (cell) { return cell && String(cell).toLowerCase().includes(query.toLowerCase()); });
    });
};
export var versionsDomain = function (state) { return state.versions; };
var versions = function (state) { return (state.versions && state.versions.versions) || []; };
export var makeSelectVersions = createSelector(versionsDomain, function (domain) { return (domain === null || domain === void 0 ? void 0 : domain.versions) || []; });
export var makeSelectLoading = createSelector(versionsDomain, function (domain) { return (domain === null || domain === void 0 ? void 0 : domain.loading) || false; });
export var makeSelectUsers = createSelector(versionsDomain, function (domain) { return (domain === null || domain === void 0 ? void 0 : domain.users) || []; });
var defaultState = {
    loading: initialState.loading,
    updating: initialState.updating,
    error: initialState.error,
    version: initialState.versions,
    touched: initialState.touched,
    noneChecked: initialState.noneChecked,
    formValidity: initialState.formValidity,
    searchQuery: initialState.searchQuery,
    users: initialState.users,
    versions: initialState.versions,
};
export var VersionsState = createSelector(searchQuery, versions, versionsDomain, function (query, selectedVersions, versionState) {
    var clonedRows = __spreadArray([], selectedVersions, true);
    var versions = {
        versions: clonedRows,
    };
    if (query) {
        versions.versions = queryVersions(query, selectedVersions);
    }
    if (versionState) {
        var newState_1 = __assign({}, defaultState);
        Object.keys(defaultState).forEach(function (s) {
            if (versionState[s]) {
                newState_1[s] = versionState[s];
            }
        });
        newState_1.filteredVersions = versions;
        return newState_1;
    }
    return defaultState;
});
